import { apiClient } from './client';

export type MetricsTab = 'finanzas' | 'jugadores' | 'operativas' | 'juegos' | 'engagement' | 'retencion' | 'marketing';

export interface MetricsCard {
  label: string;
  value: number | string;
  change?: string;
  suffix?: string;
}

export interface MetricsChartItem {
  name: string;
  value: number;
}

export interface MetricsResponse {
  cards: MetricsCard[];
  chart: MetricsChartItem[];
}

export interface FunnelStage {
  name: string;
  value: number;
  percent: number;
}

export interface FunnelResponse {
  stages: FunnelStage[];
}

export const metricsApi = {
  query: async (
    tab: MetricsTab,
    fromDate?: string,
    toDate?: string,
  ): Promise<MetricsResponse> => {
    const params: Record<string, string> = { tab };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    const { data } = await apiClient.get('/admin/metrics', { params });
    return data;
  },
  funnel: async (): Promise<FunnelResponse> => {
    const { data } = await apiClient.get('/analytics/funnel');
    return data;
  },
};
